import { h, Component } from 'preact';
import style from './style';

import moment from 'moment';
import ReactHintFactory from 'react-hint';
import 'react-hint/css/index.css';
const ReactHint = ReactHintFactory({createElement: h, Component})

var classNames = require('classnames/bind');
var cx = classNames.bind(style);
var momentDurationFormatSetup = require("moment-duration-format");
const reactStringReplace = require('react-string-replace')

momentDurationFormatSetup(moment);

export default class Search extends Component {
	constructor(props) {
        super(props);
        console.log(props);
        this.state = {
        }
	}

    renderText = () => {
        if (this.props.demo) {
            return (
                <p>{this.props.item.text}</p>
            )
        }
        let sentenceExists = false;

        if (this.props.item.context.hasOwnProperty("sentence") && this.props.item.context.sentence != null) {
            if (this.props.item.context.sentence.length != 0) {
                sentenceExists = true;
            } 
        }

        if (sentenceExists) {
            let subStringIndex = this.props.item.context.sentence.indexOf(this.props.item.text);
            let subStringEndIndex = subStringIndex + this.props.item.length - 1;

            // let highlight = reactStringReplace(this.props.item.context.highlight, /<mark>(.*?)<\/mark>/, (match, i) => (
            //     <mark>{match}</mark>
            // ))

            return (
                <p style={{color: 'rgba(0, 0, 0, 0.5)'}} class={cx("result")}>
                    {reactStringReplace(this.props.item.context.sentence, this.props.item.text, (match, i) => (
                            <span style={{color: 'black'}}>{match}</span>
                    ))}
                </p>
            )
            
        } else {
            return <p class={cx("result")}>{this.props.item.text}</p>;
        }
    }

	render() {
        let href = "https://www.youtube.com/watch?v=" + this.props.item.youtube_id + "#t=" + this.props.item.start_time;
        if (this.props.demo) {
            href = "https://www.youtube.com/watch?v=" + this.props.item.youtube_id + "#t=" + this.props.item.start_time;
        } 
        let watchButtonProps = {
            class: cx("button"),
            href: href,
            target: "__blank",
            onClick: () => {
                this.props.mixpanel.track("Clicked on Watch", {
                    url: href
                });
            },
        };

        if (this.props.item.hasOwnProperty("privacy")) {
            if (this.props.item.privacy != "public") {
                watchButtonProps["data-rh"] = "🕵️This video may be private or unlisted";
            };
        };

		return (
            <div class={cx("resultCard")}>
                <ReactHint events position="left" />
                <div class={cx("details")}>
                    <p class={cx("title")}>{this.props.item.video_title}</p>
                    <p class={cx("date")}><small>{moment(this.props.item.published_at).format("dddd, MMMM Do YYYY")} | {moment.duration(this.props.item.start_time, "seconds").format("hh:mm:ss")}</small></p>
                    {this.renderText()}
                </div>

                <div class={cx("divider")}></div>

                <div class={cx("secondary")}>
                    <div class={cx("block", {"hidden": this.props.demo})}>
                        <p class={cx("title")}>Sentiment</p>
                        <p class={cx("content")}>Coming Soon</p>
                    </div>

                    <div class={cx("block", {"hidden": this.props.demo})}>
                        <p class={cx("title")}>Comments</p>
                        <p class={cx("content")}>Coming Soon</p>
                    </div>

                    <div class={cx("block", {"hidden": this.props.demo})}>
                        <p class={cx("title")}>Tags</p>
                        <p class={cx("content")}>Coming Soon</p>
                    </div>

                    <a {...watchButtonProps}>
                        <p>Watch</p>
                    </a>
                </div>
            </div>
		)
	}
}




// WEBPACK FOOTER //
// ./components/search/searchResultCard/index.js